import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function VsIndex() {
  const comparisons = [{
    name: 'Lindy.ai',
    tagline: 'AI assistant vs full business automation',
    link: '/vs/lindy-ai',
    color: 'border-teal'
  }, {
    name: 'Zapier',
    tagline: 'Workflow automation vs a running business',
    link: '/vs/zapier',
    color: 'border-purple'
  }, {
    name: 'HubSpot',
    tagline: 'CRM platform vs complete AI operations',
    link: '/vs/hubspot',
    color: 'border-red-cta'
  }];
  return <main className="pt-20" data-id="element-2902" data-mp="24m9wjztnjj11">
      {/*
              Title: MindStream.ing vs Competitors — See Every Comparison
            */}
      <section className="relative pt-24 pb-20 lg:pt-32 lg:pb-28 px-6 bg-hero-gradient min-h-[60vh] flex flex-col justify-center overflow-hidden" data-id="element-2903" data-mp="2t2i0slv55g7">
        {/* Ambient Glow Orbs */}
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-purple/20 rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-2904" data-mp="7q2miz32e057" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-teal/20 rounded-full blur-[100px] opacity-20 pointer-events-none" data-id="element-2905" data-mp="1bburoyaxzqmv" />

        {/* Grid Pattern Overlay */}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
        backgroundImage: `radial-gradient(circle, white 1px, transparent 1px)`,
        backgroundSize: '40px 40px'
      }} data-id="element-2906" data-mp="1l15u623bpx1s" />

        <div className="inner-container relative z-10 text-center max-w-4xl mx-auto mb-16" data-id="element-2907" data-mp="se1m1o8xp2ls">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-2908" data-mp="16d1aovwg5hhy">
            <h1 className="font-poppins font-extrabold text-5xl md:text-6xl leading-tight mb-6" data-id="element-2909" data-mp="2dql74xeju00c">
              MISTR vs Everyone.
              <br data-id="element-2910" data-mp="1aee56u47ps7z" />
              <span className="text-gradient" data-id="element-2911" data-mp="1ah0aso7jlxnk">Pick Your Fight.</span>
            </h1>
            <p className="text-lg md:text-xl text-steel" data-id="element-2912" data-mp="1fc5wblx19ab4">
              See exactly why business owners are switching to full AI business
              automation.
            </p>
          </motion.div>
        </div>

        <div className="inner-container max-w-5xl" data-id="element-2913" data-mp="1ocktbijd0dug">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-2914" data-mp="rphawq8tezpr">
            {comparisons.map((comp, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} data-id="element-2915" data-mp="wokhif4g1dzu" data-mpi={i}>
                <Link to={comp.link} className={`block bg-gradient-to-br from-white/[0.05] to-white/[0.02] backdrop-blur-sm rounded-xl p-8 border-l-4 ${comp.color} border-y border-r border-white/10 shadow-lg hover:shadow-[0_0_30px_rgba(255,255,255,0.1)] hover:-translate-y-1 transition-all group`} data-id="element-2916" data-mp="cz0ddhzawty5">
                  <div className="text-sm text-steel mb-2" data-id="element-2917" data-mp="3smtf6r3vyia5">vs</div>
                  <h2 className="font-poppins font-bold text-3xl mb-4 group-hover:text-white transition-colors" data-id="element-2918" data-mp="3nku9hakob9a1">
                    {comp.name}
                  </h2>
                  <p className="text-white/80 mb-8 h-12" data-id="element-2919" data-mp="3dw2j36v9gx18">{comp.tagline}</p>
                  <div className="flex items-center gap-2 text-teal font-semibold group-hover:gap-3 transition-all" data-id="element-2920" data-mp="3dtzkhyg1lvkw">
                    See Full Comparison <ArrowRight size={18} data-id="element-2921" data-mp="34vxfz8x3oksv" />
                  </div>
                </Link>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.6
        }} className="text-center mt-16" data-id="element-2922" data-mp="2zy49sfvsrqsl">
            <p className="text-steel mb-4" data-id="element-2923" data-mp="13rlh5vbrf7cp">Don't see your tool?</p>
            <Link to="/contact" className="btn-ghost inline-block" data-id="element-2924" data-mp="p4ijnonfsypd">
              Talk to MR and we'll show you the difference
            </Link>
          </motion.div>
        </div>
      </section>
    </main>;
}